interface ResetButtonProps {
  onReset: () => void;
}

export function ResetButton({ onReset }: ResetButtonProps) {
  return (
    <div className="filter-group mb-4">
      <button
        onClick={onReset}
        className="w-full px-3 py-2.5 bg-bg-tertiary border border-border rounded-lg text-text-secondary text-sm transition-all hover:bg-border"
      >
        重置筛选
      </button>
    </div>
  );
}
